namespace advisorop.components.advisor {

    class RepGroupWrapperController {

        $router;
        selectedCompanyGroup: domains.ICompanyGroup;
        selectedCompanyGroupId: number;
        companyGroupSel: domains.ICompanyGroup;;
        static $inject = ["identityService"];
        constructor(public identityService: services.IdentityService) {
        }

        newCompanyGroupSelected(advisorFirm: domains.ICompanyGroup): void {
            this.selectedCompanyGroup = advisorFirm;
            this.companyGroupSel = this.selectedCompanyGroup;
            //this.selectedCompanyGroupId = this.companyGroupSel.id;
        }
       
        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }


    class RepGroupWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                $router: "<",
               // advisorFirm: "<"
            };
            this.controller = RepGroupWrapperController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/rep-group-wrapper.html';
        }
    }

    angular.module(Constants.APP).component("repGroupWrapper", new RepGroupWrapper());
}